module.exports = __webpack_public_path__ + "img/chivas_regal_12_anos_750ml.05fa9c68.png";